import { render, staticRenderFns } from "./CompanyChangePlanBasic.vue?vue&type=template&id=b58b0326&scoped=true&"
import script from "./CompanyChangePlanBasic.vue?vue&type=script&lang=js&"
export * from "./CompanyChangePlanBasic.vue?vue&type=script&lang=js&"
import style0 from "./CompanyChangePlanBasic.vue?vue&type=style&index=0&id=b58b0326&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58b0326",
  null
  
)

export default component.exports